import { normalize, schema } from 'normalizr';
import { JobOfferView, StructureQuestionnaireElementType, QuestionnaireElement } from './jobOffers.dto';
import { JobOffer } from './jobOffers.state';

const SCHEMA_KEY_JOB_OFFERS = 'jobOffers';

export const jobOfferSchema = new schema.Entity(SCHEMA_KEY_JOB_OFFERS, undefined, {
    idAttribute: 'jobOfferIdentifier'
});

export function convertApiJobOfferToSchema(response: JobOfferView) {
    const parsed = normalize(response, jobOfferSchema);

    const offerView = parsed.entities[SCHEMA_KEY_JOB_OFFERS][parsed.result] as JobOfferView;
    // convert JobOfferView to JobOffer
    const offer: JobOffer = {
        ...offerView,
        questionnaireStructure: {
            pages: []
        }
    };

    // for elements
    // create pages
    // page = { page: number, elements: [] }
    // section as element
    let currentPage = 0;
    let currentSection = 0;
    let order = 1;
    offerView.questionnaireStructure.elements.forEach(element => {
        if (element.pageNumber > currentPage) {
            offer.questionnaireStructure.pages.push({
                pageNumber: element.pageNumber,
                elements: []
            });
            currentPage = element.pageNumber;
            currentSection = 1;
        } else if (element.sectionNumber > currentSection) {
            const sectionBreak: QuestionnaireElement = {
                id: 'section-break',
                order: order++,
                pageNumber: 0, // we dont need these values so just set them to 0
                sectionNumber: 0,
                $type: StructureQuestionnaireElementType.SectionBreak
            };
            offer.questionnaireStructure.pages[offer.questionnaireStructure.pages.length - 1].elements.push(
                sectionBreak
            );
            currentSection = element.sectionNumber;
        }

        // add new element
        offer.questionnaireStructure.pages[offer.questionnaireStructure.pages.length - 1].elements.push({
            ...element,
            order: order++
        });
    });

    return {
        jobOfferId: parsed.result as string,
        jobOffer: offer
    };
}
